<!--<app-nav-menu></app-nav-menu>-->
<!--<router-outlet></router-outlet>-->

<div *ngIf="claims">
  <router-outlet></router-outlet>
  {{message | json}}
</div>
